import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { labelForPath } from '../../config/routeLabels';
import { SITE } from '../../config/site';

/**
 * Titre d'onglet par défaut à chaque changement de page (« Page | Nom du site »).
 * Monté avant les pages : une page qui utilise SEOHead remplace ensuite ce titre par le sien.
 */
const DocumentTitle = () => {
  const { pathname } = useLocation();
  useEffect(() => {
    const label = labelForPath(pathname);
    document.title = label ? `${label} | ${SITE.name}` : `${SITE.name} : investissement à impact social au Niger`;
  }, [pathname]);
  return null;
};

export default DocumentTitle;
